import {
  SET_HEADER_FIXED,
  TOGGLE_NAVIGATION,
  TOGGLE_COUNTRY_SELECTOR,
  TOGGLE_SEARCH,
} from './types';

const setHeaderFixed = (state, { isPinned }) => ({
  ...state,
  isPinned,
});

const toggleNavigation = state => ({
  ...state,
  isNavigationVisible: !state.isNavigationVisible,
});

const toggleCountrySelector = state => ({
  ...state,
  isCountrySelectorVisible: !state.isCountrySelectorVisible,
});

const toggleSearch = state => ({
  ...state,
  isSearchVisible: !state.isSearchVisible,
});

const reducer = {
  [SET_HEADER_FIXED]: setHeaderFixed,
  [TOGGLE_NAVIGATION]: toggleNavigation,
  [TOGGLE_COUNTRY_SELECTOR]: toggleCountrySelector,
  [TOGGLE_SEARCH]: toggleSearch,
};

export default (state = {}, action) =>
  (action.type && reducer[action.type] ? reducer[action.type](state, action) : state);
